import { computed } from 'vue'

export const years = computed(() => {
  const currentYear = new Date().getFullYear()
  return Array.from({ length: 15 }, (_, i) => currentYear + i)
})

export const onBlur = (e) => {
  if (e.target.value === '') {
    e.target.parentElement.classList.remove('focused')
  }
}

export const onFocus = (e) => {
  e.target.parentElement.classList.add('focused')
}
